import { UserNotificationPeriod } from 'src/constants/user'

export const userNotificationPeriods = [
  {
    label: 'Instant',
    value: UserNotificationPeriod.Instant,
  },
  {
    label: 'Hourly',
    value: UserNotificationPeriod.Hourly,
  },
  {
    label: 'Daily',
    value: UserNotificationPeriod.Daily,
  },
]
